import { GoogleIdentitiesRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/personal/google-identities')({
  component: GoogleIdentitiesRoute,
});
